export const isNumber = value => typeof value === 'number' && isFinite(value)
export const prepareNumericArray = (inputString: string): number[] => {
  if (inputString.length > 0)
    return inputString
      .split(',')
      .map(s => parseInt(s))
      .filter(s => !isNaN(s))

  return []
}

export const getSiteId = (site: string) => {
  return parseInt(site.at(-1))
}
